import { hasPrivilege } from 'cadenza/access-management/model/object-privilege-util';
import type { ObjecttypeInfo } from 'cadenza/objecttype/objecttype-details/associations-overview/associations-overview';

export function canModifyObjecttype(objecttype: ObjecttypeInfo): boolean {
  return !objecttype.isEnrichment && hasPrivilege(objecttype.currentUserPrivileges, 'write');
}
